// extracted by mini-css-extract-plugin
module.exports = {"topComment":"_198gV","topCommentLabel":"HxRff"};